import { render, staticRenderFns } from "./appMian.vue?vue&type=template&id=27a46b76&scoped=true&"
import script from "./appMian.vue?vue&type=script&lang=js&"
export * from "./appMian.vue?vue&type=script&lang=js&"
import style0 from "./appMian.vue?vue&type=style&index=0&id=27a46b76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a46b76",
  null
  
)

export default component.exports